"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

(function (webf) {
  webf.lang.fr = webf.lang.fr || {};
  webf.lang.fr.datagrid = {
    search: 'Rechercher',
    refresh: 'Rafraîchir',
    allColumns: 'Toutes les colonnes',
    abbrColumn: '#',
    today: 'Aujourd\'hui',
    noDate: 'Sans date'
  };
})(_core["default"]);